// CHARLOTTE SHAPE - mobile product zoom overlay.
// Mobile only: uses the same native horizontal scroll/snap principle as the product carousel.
(function () {
  "use strict";

  var MOBILE_QUERY = "(max-width: 699px)";
  var ROOT_OPEN_CLASS = "charlotte-mobile-product-zoom-open";
  var mediaQuery = window.matchMedia(MOBILE_QUERY);
  var pointerStart = null;
  var overlay = null;
  var track = null;
  var progress = null;
  var rafId = null;

  function isMobileProductZoomEnabled() {
    return mediaQuery.matches;
  }

  function getImageMedia(target) {
    if (!target || typeof target.closest !== "function") {
      return null;
    }

    return target.closest('.shopify-section--main-product product-gallery .product-gallery__media[data-media-type="image"]');
  }

  function getVisibleImageMedia(carousel) {
    if (!carousel) {
      return [];
    }

    if (carousel.visibleItems) {
      return carousel.visibleItems.filter(function (item) {
        return !item.hidden && item.getAttribute("data-media-type") === "image";
      });
    }

    return Array.from(carousel.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden])'));
  }

  function getImageData(mediaItems) {
    return mediaItems
      .map(function (media) {
        var image = media.querySelector("img");

        if (!image) {
          return null;
        }

        return {
          src: image.currentSrc || image.src,
          srcset: image.srcset || "",
          sizes: image.sizes || "100vw",
          alt: image.alt || ""
        };
      })
      .filter(Boolean);
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function updateProgress() {
    if (!track || !progress) {
      return;
    }

    var count = track.children.length;
    var size = count > 0 ? 100 / count : 0;
    var maxScroll = track.scrollWidth - track.clientWidth;
    var maxOffset = Math.max(0, 100 - size);
    var offset = 0;

    if (maxScroll > 1) {
      offset = clamp((track.scrollLeft / maxScroll) * maxOffset, 0, maxOffset);
    }

    progress.style.setProperty("--charlotte-mobile-zoom-progress-size", size + "%");
    progress.style.setProperty("--charlotte-mobile-zoom-progress-offset", offset + "%");
  }

  function requestProgressUpdate() {
    if (rafId !== null) {
      return;
    }

    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      updateProgress();
    });
  }

  function closeZoom() {
    if (rafId !== null) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }

    if (track) {
      track.removeEventListener("scroll", requestProgressUpdate);
    }

    if (overlay) {
      overlay.remove();
    }

    overlay = null;
    track = null;
    progress = null;
    pointerStart = null;
    document.documentElement.classList.remove(ROOT_OPEN_CLASS);
  }

  function createZoomSlide(item) {
    var slide = document.createElement("div");
    var image = document.createElement("img");

    slide.className = "charlotte-mobile-zoom__slide";
    image.className = "charlotte-mobile-zoom__image";
    image.src = item.src;
    image.alt = item.alt;
    image.decoding = "async";
    image.loading = "eager";

    if (item.srcset) {
      image.srcset = item.srcset;
    }

    if (item.sizes) {
      image.sizes = item.sizes;
    }

    slide.appendChild(image);

    return slide;
  }

  function openZoom(items, index) {
    closeZoom();

    if (!items.length) {
      return;
    }

    overlay = document.createElement("div");
    overlay.className = "charlotte-mobile-zoom";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");

    var closeButton = document.createElement("button");
    closeButton.className = "charlotte-mobile-zoom__close";
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", "Inchide imaginea");

    track = document.createElement("div");
    track.className = "charlotte-mobile-zoom__track";

    items.forEach(function (item) {
      track.appendChild(createZoomSlide(item));
    });

    progress = document.createElement("div");
    progress.className = "charlotte-mobile-zoom__progress";
    progress.setAttribute("aria-hidden", "true");
    progress.appendChild(document.createElement("span"));

    overlay.appendChild(track);
    overlay.appendChild(closeButton);
    overlay.appendChild(progress);
    document.body.appendChild(overlay);
    document.documentElement.classList.add(ROOT_OPEN_CLASS);

    closeButton.addEventListener("click", closeZoom);
    track.addEventListener("scroll", requestProgressUpdate, { passive: true });

    window.requestAnimationFrame(function () {
      var startIndex = clamp(index, 0, items.length - 1);
      track.scrollLeft = startIndex * track.clientWidth;
      updateProgress();
    });
  }

  document.addEventListener(
    "pointerdown",
    function (event) {
      if (!isMobileProductZoomEnabled() || event.button > 0) {
        return;
      }

      var media = getImageMedia(event.target);

      if (!media || media.hidden) {
        return;
      }

      pointerStart = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        time: Date.now(),
        media: media
      };
    },
    { passive: true }
  );

  document.addEventListener(
    "pointerup",
    function (event) {
      if (!pointerStart || pointerStart.id !== event.pointerId) {
        return;
      }

      var start = pointerStart;
      pointerStart = null;

      if (!isMobileProductZoomEnabled()) {
        return;
      }

      var deltaX = Math.abs(event.clientX - start.x);
      var deltaY = Math.abs(event.clientY - start.y);

      if (deltaX > 8 || deltaY > 8 || Date.now() - start.time > 700) {
        return;
      }

      var carousel = start.media.closest("media-carousel");
      var mediaItems = getVisibleImageMedia(carousel);
      var openIndex = mediaItems.indexOf(start.media);

      if (openIndex < 0) {
        return;
      }

      openZoom(getImageData(mediaItems), openIndex);
    },
    { passive: true }
  );

  document.addEventListener("pointercancel", function () {
    pointerStart = null;
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && overlay) {
      closeZoom();
    }
  });

  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", function (event) {
      if (!event.matches) {
        closeZoom();
      }
    });
  } else if (typeof mediaQuery.addListener === "function") {
    mediaQuery.addListener(function (event) {
      if (!event.matches) {
        closeZoom();
      }
    });
  }
})();
